import React from 'react';

import './_matchup-record.scss';


const MatchupRecord = (props) =>
  (<div className="col-lg-6 records">
    <div className="row mx-lg-2 mb-5 mb-lg-2 clippedbox--color-dark text-center">
      <h2 className="heading--gray my-4 col-12">{props.title}</h2>
      <div className="offset-1 col-5 r px-0 mb-1">
        <p className="heading--gray">Matchup</p>
      </div>
      <div className="col-2 px-0">
        <p className="heading--gray">Year</p>
      </div>
      <div className=" col-2 px-0">
        <p className="heading--gray">Week</p>
      </div>
      <div className=" col-2 px-0">
        <p className="heading--gray">{props.label}</p>
      </div>
        {props.data.map((item, i) =>(
          <React.Fragment key={i}>
            <div className="col-12 alt">
              <div className="row my-2 flex-center">
                <div className="col-1 pr-0">
                  <p className="rank-number">{i + 1}</p>
                </div>
                <div className="col-5 text-center px-0">
                  <p>{item.winner} <span>- {item.scoreWin}</span></p>
                  <p className="heading--gray mx-2 text-center">VS</p>
                  <p>{item.loser} <span>- {item.scoreLose}</span></p>
                </div>
                <div className="col-2 text-center">
                  <p>{item.year}</p>
                </div>
                <div className="col-2 text-center">
                  <p>{item.week}</p>
                </div>
                <div className= "col-2 text-center">
                  {props.show === 'Margin' &&
                    <p>{item.margin}</p>
                  }  
                  {props.show === 'Points' &&
                    <p>{item.sumScore}</p>
                  }
                  {props.show === 'scoreWin' &&
                    <p>{item.scoreWin}</p>
                  }  
                  {props.show === 'scoreLose' &&
                    <p>{item.scoreLose}</p>
                  }  
                    
                  
                </div>
              </div>
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>);

export default MatchupRecord;
